import { LangResources } from '@providers/TranslateProvider';

import { components } from '@features/shared/api/game';

export const TIME_PRESSURE = 10;

export const TIME_CONTROL: Record<components['schemas']['ClockControlType'], keyof LangResources> =
  {
    Blitz: '@features/game/pages/GamePage/Time Control Blitz',
    Rapid: '@features/game/pages/GamePage/Time Control Rapid',
    Classic: '@features/game/pages/GamePage/Time Control Classic',
    Bullet: '@features/game/pages/GamePage/Time Control Bullet',
  };
